import { render, staticRenderFns } from "./DeadEnd.vue?vue&type=template&id=5a73a055&scoped=true"
import script from "./DeadEnd.vue?vue&type=script&lang=js"
export * from "./DeadEnd.vue?vue&type=script&lang=js"
import style0 from "./DeadEnd.vue?vue&type=style&index=0&id=5a73a055&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a73a055",
  null
  
)

export default component.exports